/**
 * Purpose:
 * Central source of truth for upload-session status values used across
 * reconciliation, dashboard, and shared table UI logic.
 */
export const SESSION_STATUS = {
    OPEN: 'OPEN',
    PROCESSING: 'PROCESSING',
    PROCESSED: 'PROCESSED',
    RECONCILED: 'RECONCILED',
    FAILED: 'FAILED',
    CLOSED: 'CLOSED',
} as const;

export type SessionStatus =
    (typeof SESSION_STATUS)[keyof typeof SESSION_STATUS];

/**
 * Normalizes unknown backend/UI status values for safe comparisons.
 * Keeps behavior unchanged by returning the same uppercase string format
 * already used throughout the application.
 */
export function normalizeSessionStatus(value: unknown): string {
    return String(value ?? '').trim().toUpperCase();
}
